// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --navbar-height: 70px;
    --navbar-bg: var(--brand-primary, #0F172A);
    --navbar-text: #FFFFFF;
    --dropdown-bg: #FFFFFF;
    --dropdown-hover: #F1F5F9;
}

/* ─── Barra principal ─── */
.custom-navbar {
    background-color: var(--navbar-bg);
    height: var(--navbar-height);
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 1000;
    box-shadow: 0 2px 10px rgba(0,0,0,0.15);
    overflow: visible;
}

/* ─── Logo ─── */
.navbar-brand {
    display: flex;
    align-items: center;
    text-decoration: none;
    height: 100%;
    flex-shrink: 0;
}

.navbar-logo {
    height: 85px;
    width: auto;
    position: relative;
    top: 15px;
    z-index: 1002;
    filter: drop-shadow(0 4px 6px rgba(0,0,0,0.2));
    transition: transform 0.2s ease;
}

.navbar-logo:hover {
    transform: scale(1.07);
}

/* ─── Links centrales (desktop) ─── */
.navbar-center {
    display: flex;
    align-items: center;
    gap: 4px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}

.nav-link {
    display: flex;
    align-items: center;
    gap: 7px;
    color: rgba(255, 255, 255, 0.75);
    text-decoration: none;
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 500;
    transition: background 0.2s, color 0.2s;
    white-space: nowrap;
}

.nav-link i {
    font-size: 0.85rem;
}

.nav-link:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
}

.nav-link--active {
    background: rgba(210, 248, 0, 0.15);
    color: var(--brand-accent, #D2F800);
    font-weight: 600;
}

.nav-link--active i {
    color: var(--brand-accent, #D2F800);
}

/* ─── Zona derecha ─── */
.navbar-right {
    display: flex;
    align-items: center;
    gap: 14px;
    position: relative;
    flex-shrink: 0;
}

.navbar-username {
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.9rem;
    font-weight: 500;
}

/* ─── Botón hamburguesa ─── */
.menu-toggle-btn {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 1.1rem;
    flex-shrink: 0;
}

.menu-toggle-btn:hover,
.menu-toggle-btn.active {
    background: var(--brand-accent, #D2F800);
    color: var(--brand-primary, #0F172A);
    border-color: var(--brand-accent, #D2F800);
}

/* ─── Dropdown ─── */
.dropdown-menu {
    position: absolute;
    top: calc(100% + 12px);
    right: 0;
    width: 260px;
    background-color: var(--dropdown-bg);
    border-radius: 12px;
    box-shadow: 0 10px 25px -5px rgba(0,0,0,0.15), 0 8px 10px -6px rgba(0,0,0,0.1);
    padding: 8px;
    animation: fadeInMenu 0.2s ease-out;
    border: 1px solid var(--border-light, #E2E8F0);
    z-index: 1001;
}

.dropdown-menu::before {
    content: '';
    position: absolute;
    top: -6px;
    right: 14px;
    width: 12px;
    height: 12px;
    background-color: var(--dropdown-bg);
    transform: rotate(45deg);
    border-left: 1px solid var(--border-light, #E2E8F0);
    border-top: 1px solid var(--border-light, #E2E8F0);
}

@keyframes fadeInMenu {
    from { opacity: 0; transform: translateY(-8px); }
    to   { opacity: 1; transform: translateY(0); }
}

.menu-item {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 11px 16px;
    border: none;
    background: none;
    text-align: left;
    color: var(--text-main, #1E293B);
    font-size: 0.95rem;
    font-weight: 500;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.15s;
    text-decoration: none;
    box-sizing: border-box;
}

.menu-item:hover {
    background-color: var(--dropdown-hover);
    color: var(--brand-primary);
}

.menu-item i {
    width: 20px;
    text-align: center;
    color: var(--text-muted, #64748B);
    font-size: 0.95rem;
}

.menu-item:hover i {
    color: var(--brand-primary);
}

.menu-divider {
    height: 1px;
    background-color: var(--border-light, #E2E8F0);
    margin: 6px 0;
}

/* Sección de links móvil dentro del dropdown */
.mobile-nav-section {
    display: none;
}

.menu-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999;
    cursor: default;
}

/* ─── Responsive ─── */
@media (max-width: 768px) {
    .custom-navbar {
        padding: 0 16px;
        height: 60px;
    }

    .navbar-logo {
        height: 70px;
        top: 10px;
    }

    /* Ocultar links centrales en móvil */
    .navbar-center {
        display: none;
    }

    /* Mostrar links en el dropdown móvil */
    .mobile-nav-section {
        display: block;
    }

    .navbar-username {
        display: none;
    }

    .dropdown-menu {
        width: 88vw;
        max-width: 300px;
        right: -8px;
    }
}

@media (min-width: 769px) and (max-width: 1024px) {
    .custom-navbar {
        padding: 0 20px;
    }

    .nav-link span {
        display: none;
    }

    .nav-link {
        padding: 8px 12px;
        font-size: 1rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,0CAA0C;IAC1C,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA,4BAA4B;AAC5B;IACI,kCAAkC;IAClC,4BAA4B;IAC5B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,uCAAuC;IACvC,iBAAiB;AACrB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,8CAA8C;IAC9C,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gCAAgC;IAChC,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;AACvC;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,8BAA8B;AAC9B;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;IAEI,wCAAwC;IACxC,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,8EAA8E;IAC9E,YAAY;IACZ,mCAAmC;IACnC,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,wBAAwB;IACxB,mDAAmD;IACnD,kDAAkD;AACtD;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;IAClC,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,8CAA8C;IAC9C,aAAa;AACjB;;AAEA,+CAA+C;AAC/C;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,SAAS;IACb;;IAEA,qCAAqC;IACrC;QACI,aAAa;IACjB;;IAEA,uCAAuC;IACvC;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ","sourcesContent":[":root {\n    --navbar-height: 70px;\n    --navbar-bg: var(--brand-primary, #0F172A);\n    --navbar-text: #FFFFFF;\n    --dropdown-bg: #FFFFFF;\n    --dropdown-hover: #F1F5F9;\n}\n\n/* ─── Barra principal ─── */\n.custom-navbar {\n    background-color: var(--navbar-bg);\n    height: var(--navbar-height);\n    padding: 0 24px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: sticky;\n    top: 0;\n    z-index: 1000;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.15);\n    overflow: visible;\n}\n\n/* ─── Logo ─── */\n.navbar-brand {\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    height: 100%;\n    flex-shrink: 0;\n}\n\n.navbar-logo {\n    height: 85px;\n    width: auto;\n    position: relative;\n    top: 15px;\n    z-index: 1002;\n    filter: drop-shadow(0 4px 6px rgba(0,0,0,0.2));\n    transition: transform 0.2s ease;\n}\n\n.navbar-logo:hover {\n    transform: scale(1.07);\n}\n\n/* ─── Links centrales (desktop) ─── */\n.navbar-center {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.nav-link {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    color: rgba(255, 255, 255, 0.75);\n    text-decoration: none;\n    padding: 8px 16px;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    transition: background 0.2s, color 0.2s;\n    white-space: nowrap;\n}\n\n.nav-link i {\n    font-size: 0.85rem;\n}\n\n.nav-link:hover {\n    background: rgba(255, 255, 255, 0.1);\n    color: #fff;\n}\n\n.nav-link--active {\n    background: rgba(210, 248, 0, 0.15);\n    color: var(--brand-accent, #D2F800);\n    font-weight: 600;\n}\n\n.nav-link--active i {\n    color: var(--brand-accent, #D2F800);\n}\n\n/* ─── Zona derecha ─── */\n.navbar-right {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    position: relative;\n    flex-shrink: 0;\n}\n\n.navbar-username {\n    color: rgba(255, 255, 255, 0.8);\n    font-size: 0.9rem;\n    font-weight: 500;\n}\n\n/* ─── Botón hamburguesa ─── */\n.menu-toggle-btn {\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    color: white;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-size: 1.1rem;\n    flex-shrink: 0;\n}\n\n.menu-toggle-btn:hover,\n.menu-toggle-btn.active {\n    background: var(--brand-accent, #D2F800);\n    color: var(--brand-primary, #0F172A);\n    border-color: var(--brand-accent, #D2F800);\n}\n\n/* ─── Dropdown ─── */\n.dropdown-menu {\n    position: absolute;\n    top: calc(100% + 12px);\n    right: 0;\n    width: 260px;\n    background-color: var(--dropdown-bg);\n    border-radius: 12px;\n    box-shadow: 0 10px 25px -5px rgba(0,0,0,0.15), 0 8px 10px -6px rgba(0,0,0,0.1);\n    padding: 8px;\n    animation: fadeInMenu 0.2s ease-out;\n    border: 1px solid var(--border-light, #E2E8F0);\n    z-index: 1001;\n}\n\n.dropdown-menu::before {\n    content: '';\n    position: absolute;\n    top: -6px;\n    right: 14px;\n    width: 12px;\n    height: 12px;\n    background-color: var(--dropdown-bg);\n    transform: rotate(45deg);\n    border-left: 1px solid var(--border-light, #E2E8F0);\n    border-top: 1px solid var(--border-light, #E2E8F0);\n}\n\n@keyframes fadeInMenu {\n    from { opacity: 0; transform: translateY(-8px); }\n    to   { opacity: 1; transform: translateY(0); }\n}\n\n.menu-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    padding: 11px 16px;\n    border: none;\n    background: none;\n    text-align: left;\n    color: var(--text-main, #1E293B);\n    font-size: 0.95rem;\n    font-weight: 500;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.15s;\n    text-decoration: none;\n    box-sizing: border-box;\n}\n\n.menu-item:hover {\n    background-color: var(--dropdown-hover);\n    color: var(--brand-primary);\n}\n\n.menu-item i {\n    width: 20px;\n    text-align: center;\n    color: var(--text-muted, #64748B);\n    font-size: 0.95rem;\n}\n\n.menu-item:hover i {\n    color: var(--brand-primary);\n}\n\n.menu-divider {\n    height: 1px;\n    background-color: var(--border-light, #E2E8F0);\n    margin: 6px 0;\n}\n\n/* Sección de links móvil dentro del dropdown */\n.mobile-nav-section {\n    display: none;\n}\n\n.menu-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 999;\n    cursor: default;\n}\n\n/* ─── Responsive ─── */\n@media (max-width: 768px) {\n    .custom-navbar {\n        padding: 0 16px;\n        height: 60px;\n    }\n\n    .navbar-logo {\n        height: 70px;\n        top: 10px;\n    }\n\n    /* Ocultar links centrales en móvil */\n    .navbar-center {\n        display: none;\n    }\n\n    /* Mostrar links en el dropdown móvil */\n    .mobile-nav-section {\n        display: block;\n    }\n\n    .navbar-username {\n        display: none;\n    }\n\n    .dropdown-menu {\n        width: 88vw;\n        max-width: 300px;\n        right: -8px;\n    }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n    .custom-navbar {\n        padding: 0 20px;\n    }\n\n    .nav-link span {\n        display: none;\n    }\n\n    .nav-link {\n        padding: 8px 12px;\n        font-size: 1rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
